import React from 'react'
import styled, { css } from 'styled-components'
import ButtonShell from 'components/elements/Buttons/ButtonShell'

export const ButtonPrimaryCSS = css`
  background-color: ${({ theme }) => theme.color.primary};
  border-radius: 25.5px;
  display: inline-block;
  border: 2px solid transparent;
  transition: all 0.3s ease-in-out;
  min-width: 240px;

  & > a,
  & > button {
    text-align: center;
    color: ${(props) => props.theme.color.light} !important;
    font-size: 16px;
    line-height: 16px;
    font-weight: ${({ theme }) => theme.font.weight.bold};
    padding: 10px 15px;
    width: 100%;
    height: 100%;
    display: block;
    text-decoration: none !important;
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    background-color: transparent;
    border: 2px solid ${({ theme }) => theme.color.primary};

    & > a {
      color: ${({ theme }) => theme.color.primary} !important;
    }
  }
`

const StyledButton = styled.span`
  ${ButtonPrimaryCSS};
`

interface ButtonPrimaryProps {
  isAnchor?: boolean
  isCustom?: boolean
  to: string
  className?: string
  target?: string
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  isAnchor = false,
  isCustom = false,
  to,
  children,
  className = '',
  target = '',
}) => (
  <StyledButton className={className}>
    {isCustom ? (
      children
    ) : (
      <ButtonShell to={to} isAnchor={isAnchor} target={target}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonPrimary
